module.exports = __webpack_public_path__ + "static/Montserrat-200-94603128108f9cf9b26626564265c1d0.ttf";